import { WifiOff } from 'lucide-react'
import { useTranslation } from '@cravo/i18n'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'

export function OfflineBanner() {
  const { t } = useTranslation()
  const isOnline = useOnlineStatus()

  if (isOnline) return null

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '10px 20px',
        background: 'var(--ink-900)',
        color: 'white',
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      <WifiOff size={15} style={{ flexShrink: 0 }} />
      <span>{t('components.offlineBanner.message')}</span>
    </div>
  )
}
